export var ModifyShotValue2 = {
  name: "shot_2pt_to_3pt",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.shot.value.2",
  showOn: [{ state: "editState", value: "shot-value-2", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "shot_value_description",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [true],
      options: {
        layout: "description-text",
        text: "edit.shot.value.2.description",
      },
      actionGroups: [],
    },
    {
      name: "shot_change_value",
      component: "TypeButton",
      layout: "match-button action",
      mode: "enable",
      text: "edit.shot.value.confirm",
      showForInsert: true,
      showOn: [true],
      actionGroups: [
        {
          actions: [
            { action: "saveData", value: "3pt", type: "eventType" },
            { action: "clearData", value: ["subType"], type: "main" },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            {
              action: "nextState",
              value: null,
              type: "editState",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};

export var ModifyShotValue3 = {
  name: "shot_3pt_to_2pt",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.shot.value.3",
  showOn: [{ state: "editState", value: "shot-value-3", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "change_shot_value",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "saveData", value: "2pt", type: "eventType", event: "edit" },
            {
              action: "nextState",
              value: "shot-type",
              type: "editState",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
